import React, { useEffect, useState } from "react"

import OrderTable from "./UI/OneStepAllocationOrderTable";
import OrderForm from "./UI/OrderForm";
import OpenWeekend from "./UI/OneStepOpenWeekend";
import withOrder from "./withOrder";
import PaymentMessage from "./UI/PaymentMessage"

const formatDate = date => {
  if (!date) {
    return null
  }

  return new Intl.DateTimeFormat('en-AU', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(new Date(`${date}T00:00:00`))
}

const purchasedAdditionalProducts = (additionalProducts, orderDetails = []) => {
  if (additionalProducts === null) {
    return []
  }

  return additionalProducts.filter(product =>
    orderDetails.some(orderDetail =>
      orderDetail.productId === product.id &&
      Number(orderDetail.quantity) > 0
    )
  )
}

const OneStepAllocationOrderForm = props => {
  const [additionalProducts, setAdditionalProducts] = useState([])
  const [productsPath, setProductsPath] = useState(null)
  const [totalAmount, setTotalAmount] = useState(props.showOpenWeekendInfo.amount)
  const orderId = props.order.id
  const deliveryTimeframe = props.order.releaseYear.deliveryTimeframe || 'up to 4 weeks'
  const eftCutoffDate =
    formatDate(props.order.releaseYear.eftCutoffDate) || 'Wednesday 5 November 2025'

  useEffect(() => fetchProducts(), []);
  const [selfPickUp, setSelfPickUp] = useState(props.order.attendingOpenWeekend)

  const fetchProducts = () => {
    fetch(`${props.additionalProductsPath}.json`, {
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    }).then(response => response.json())
      .then(response => {
        setAdditionalProducts(response.additional_products)
        setProductsPath(response.productsPath)
      });
  }

  if (props.order.status == 'eft_pending') {
    return (
      <div>
        <PaymentMessage orderStatus={props.order.status}>
          <h3>Thank you for your order</h3>
          <p>You have chosen to pay by EFT direct bank transfer.</p>
          <p>A copy of your invoice has been e-mailed to you. Our bank details and your order number are on your invoice.</p>
          <p>Please reference your order number when you perform the bank transfer so we can link your payment to your order.</p>
          <p>Payment must be received by {eftCutoffDate}. Your order will be packed as soon as your payment is confirmed.</p>
          {props.order.attendingOpenWeekend && (
            <div>
              <p>You have chosen to pick up your order from the winery.</p>
              <p>If you are picking up your order outside of the Members Tasting days please e-mail us at <a href="mailto:winery@wdce.com.au">winery@wdce.com.au</a> or call us on 03 5433 3133 to make an appointment.</p>
              <p><b>2026 Winter Release Members Tasting Weekend - Friday 17th July to Sunday 19th July.</b></p>
              <p><a href="https://wildduckcreekestate.com.au/member-events/">Book Your Attendance Here (Limited)</a> using the ﻿Tasting Days access password﻿ <b>2026Winter.</b> (include the full stop in the password). Bookings are essential for catering purposes.</p>
            </div>
          ) || (
              <div>
                <p>It will likely be sooner, however please allow {deliveryTimeframe} for delivery.</p>
              </div>
            )}
        </PaymentMessage>
        <h2 className="text-center">Your {props.order.releaseYear.year} Order</h2>
        <OrderTable
          additionalProducts={purchasedAdditionalProducts(additionalProducts, props.order.orderDetails)}
          productsPath={productsPath}
          orderId={orderId}
          {...props.order}
          setTotalAmount={setTotalAmount}
          selfPickUp={selfPickUp}
          paid={true}
        />
      </div>)
  } else if (props.order.status == 'paid') {
    return (
      <div>
        <PaymentMessage orderStatus={props.order.status}>
          <h3>Thank you for your order</h3>
          <p>Your credit credit card payment has been received.</p>
          <p>A copy of your invoice has been e-mailed to you.</p>
          {props.order.attendingOpenWeekend && (
            <div>
              <p>You have chosen to pick up your order from the winery.</p>
              <p>If you are picking up your order outside of the Members Tasting days please e-mail us at <a href="mailto:winery@wdce.com.au">winery@wdce.com.au</a> or call us on 03 5433 3133 to make an appointment.</p>
              <p><b>2026 Winter Release Members Tasting Weekend - Friday 17th July to Sunday 19th July.</b></p>
              <p><a href="https://wildduckcreekestate.com.au/member-events/">Book Your Attendance Here (Limited)</a> using the ﻿Tasting Days access password﻿ <b>2026Winter.</b> (include the full stop in the password). Bookings are essential for catering purposes.</p>
            </div>
          ) || (
              <div>
                <p>It will likely be sooner, however please allow {deliveryTimeframe} for delivery.</p>
              </div>
            )}
        </PaymentMessage>
        <h2 className="text-center">Your {props.order.releaseYear.year} Order</h2>
        <OrderTable
          additionalProducts={purchasedAdditionalProducts(additionalProducts, props.order.orderDetails)}
          productsPath={productsPath}
          orderId={orderId}
          {...props.order}
          setTotalAmount={setTotalAmount}
          selfPickUp={selfPickUp}
          paid={true}
        />
      </div>)
  } else {
    return (
      <OrderForm
        order={props.order}
        handleOrderUpdate={props.updateOrder}
        {...props}
        totalAmount={totalAmount}
        selfPickUp={selfPickUp}
      >
        <h2 className="text-center">Your {props.order.releaseYear.year} {props.currentAllocationPeriod} Release</h2>
        <OrderTable
          additionalProducts={additionalProducts}
          productsPath={productsPath}
          orderId={orderId}
          handleOrderUpdate={props.updateOrder}
          selfPickUp={selfPickUp}
          {...props.order}
          setTotalAmount={setTotalAmount}
          paid={false} />

        <hr />

        <OpenWeekend
          order={props.order}
          showOpenWeekendInfo={props.showOpenWeekendInfo}
          handleAttendingOpenWeekendChange={props.updateOrder}
          setSelfPickUp={setSelfPickUp}
          {...props}
        />
      </OrderForm>
    )
  }
}

export default withOrder(OneStepAllocationOrderForm)